import { oz } from '@weft/utils';
import { PlanOverviewSchema } from './plan-overview-schema';

export const GetPlanOverviewResponseSchema = oz.object({
  plan: PlanOverviewSchema,
}).openapi('GetPlanOverviewResponse');

export type GetPlanOverviewResponse = oz.infer<typeof GetPlanOverviewResponseSchema>;